import React from "react";
import PropTypes from "prop-types";

export default function InfoCircle(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.6667 8V15.3333H9.33333V8H10.6667Z" fill="#B2C4F4" />
      <path d="M10.6667 6V4.66667H9.33333V6H10.6667Z" fill="#B2C4F4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5229 20 10C20 4.47713 15.5228 0 10 0C4.47715 0 0 4.47713 0 10C0 15.5229 4.47715 20 10 20ZM10 18.6667C14.7865 18.6667 18.6667 14.7865 18.6667 10C18.6667 5.21354 14.7865 1.33333 10 1.33333C5.21354 1.33333 1.33333 5.21354 1.33333 10C1.33333 14.7865 5.21354 18.6667 10 18.6667Z"
        fill="#B2C4F4"
      />
    </svg>
  );
}

InfoCircle.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

InfoCircle.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
